import React, { useState } from 'react';
import Page from '../ui/Page';
import { makeSimpleForm, isValidForm, FormStateModel } from '../utils/FormUtils';
import { useTranslation } from 'react-i18next';
import { defineMessages } from '@vistaprint-org/digital-i18n-utils';
import WebsiteModel, { websiteSchema } from '../../models/WebsiteModel';
import PageBaseProps from './PageBase';
import isEmpty from 'lodash/isEmpty';

const messages = defineMessages({
  title: 'Website',
  desc: 'Add your website url.',
  url: 'Website url',
  label: 'What do you want to name this section?',
});

const WebsitePage: React.FC<PageBaseProps<WebsiteModel>> = (props) => {
  const { t } = useTranslation();
  const initialData = props.formData || {
    label: t(messages.title.id).toString(),
    url: '',
  };
  const [website, setWebsite] = useState<FormStateModel<WebsiteModel>>({
    data: initialData,
    errors: {
      label: null,
      url: null,
    },
    dirty: {
      label: !isEmpty(initialData.label),
      url: !isEmpty(initialData.url),
    },
  });

  const handleSubmit = () => {
    props.onSubmit({ key: 'websiteModel', data: website.data });
  };

  const enableSubmit = (): boolean => {
    return isValidForm<WebsiteModel>(website.data, websiteSchema);
  };

  return (
    <Page
      title={t(messages.title.id)}
      desc={t(messages.desc.id)}
      enableSubmit={enableSubmit}
      handleSubmit={handleSubmit}
      isNewBlock={!props.formData}
    >
      {makeSimpleForm(website, websiteSchema, t, 'client.components.pages.WebsitePage', setWebsite)}
    </Page>
  );
};

export default WebsitePage;
